import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, CircleAlert, CircleCheck } from 'lucide-react';
import type { AssistantMessage } from '@/lib/ai-assistant/types';
import { AssistantMessageItem } from './AssistantMessageItem';

export function AssistantStepGroup({ messages, failed }: { messages: AssistantMessage[]; failed: number }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="assistant-step-group">
      <button
        type="button"
        className="flex w-full items-center gap-1.5 px-1 text-left text-xs text-muted-foreground hover:text-foreground"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
      >
        {failed > 0
          ? <CircleAlert className="h-3.5 w-3.5 shrink-0 text-amber-500" />
          : <CircleCheck className="h-3.5 w-3.5 shrink-0 text-primary" />}
        <span>{t('aiAssistant.steps', { count: messages.length })}</span>
        {failed > 0 && <span>· {t('aiAssistant.stepsFailed', { count: failed })}</span>}
        <ChevronDown className={`ml-auto h-3.5 w-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="mt-1.5 space-y-1.5 border-l border-border pl-2">
          {messages.map((message) => (
            <AssistantMessageItem key={message.id} message={message} canResolve={false} resolving={false} onResolve={() => {}} />
          ))}
        </div>
      )}
    </div>
  );
}
